import { useEffect } from "react";

/**
 * Injects a JSON-LD structured data block into <head> for the given route.
 * Uses schema.org TouristTrip which gives Google rich results:
 * distance/duration/geo coordinates surface in search.
 */
export const RouteSchema = ({ route }) => {
    useEffect(() => {
        if (!route) return undefined;
        const script = document.createElement("script");
        script.type = "application/ld+json";
        script.id = "route-jsonld";
        const url = typeof window !== "undefined" ? window.location.href : "";
        const heroImage = route.hero_image?.startsWith("/api/")
            ? `${process.env.REACT_APP_BACKEND_URL}${route.hero_image}`
            : route.hero_image;
        const data = {
            "@context": "https://schema.org",
            "@type": "TouristTrip",
            name: route.name,
            description: route.summary,
            url,
            image: heroImage,
            itinerary: {
                "@type": "ItemList",
                itemListElement: (route.highlights || []).map((h, i) => ({
                    "@type": "ListItem",
                    position: i + 1,
                    name: h,
                })),
            },
            offers: {
                "@type": "Offer",
                price: "0",
                priceCurrency: "EUR",
                availability: "https://schema.org/InStock",
                url,
            },
            additionalProperty: [
                { "@type": "PropertyValue", name: "Distance", value: `${route.distance_km} km` },
                { "@type": "PropertyValue", name: "Duration", value: `${route.duration_hours} hours` },
                { "@type": "PropertyValue", name: "Difficulty", value: route.difficulty },
                { "@type": "PropertyValue", name: "Road type", value: route.road_type },
                ...(route.elevation_gain_m ? [{ "@type": "PropertyValue", name: "Elevation gain", value: `${route.elevation_gain_m} m` }] : []),
            ],
            geo: {
                "@type": "GeoCoordinates",
                latitude: route.center?.[0],
                longitude: route.center?.[1],
            },
            provider: {
                "@type": "Organization",
                name: "MotorcycleRoutesIreland.com",
                url: "https://motorcycleroutesireland.com",
            },
        };
        script.text = JSON.stringify(data);
        // Replace any previous
        const prev = document.getElementById("route-jsonld");
        if (prev) prev.remove();
        document.head.appendChild(script);
        return () => {
            const el = document.getElementById("route-jsonld");
            if (el) el.remove();
        };
    }, [route]);
    return null;
};
